export default "__VITE_ASSET__ee635f05__"